import Image from "next/image";
import styles from "./prestorming.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
import dynamic from "next/dynamic";
import axios from 'axios';
import handIcon from "../../assets/images/header/touch-01.png";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Chennai = dynamic(() => import("../prestromong-chennai/pre-chennai"));
const Delhi = dynamic(() => import("../prestromong-chennai/pre-delhi"));
const Bengaluru = dynamic(() => import("../prestromong-chennai/pre-bengaluru"));
const Trivandrum = dynamic(() => import("../prestromong-chennai/pre-trivandrum"));
const Trichy = dynamic(() => import("../prestromong-chennai/pre-trichy"));
const Salem = dynamic(() => import("../prestromong-chennai/pre-salem"));
const Coimbatore = dynamic(() => import("../prestromong-chennai/pre-coimbatore"));
const Madurai = dynamic(() => import("../prestromong-chennai/pre-madurai"));
const Hyderabad = dynamic(() => import("../prestromong-chennai/pre-hyderabad"));
const Content = dynamic(() => import("../prestromong-chennai/pre-content"));
const ContentOne = dynamic(()=>import("../prestromong-chennai/pre-contentone"));
const Online = dynamic(() => import("../prestromong-chennai/pre-online"));
//const BranchAddress = dynamic(()=>import("../../components/branch-address"));
import Prelims_Form from "./prestorming-form";
import { useEffect } from "react";
import { useRouter } from "next/router"; 
import Prelimsmain from "../../assets/images/upsc/prestorming/Prestorming-Batch-6---Web-Banner.jpg"; 
import MobUpsPerlims from "../../assets/images/upsc/prestorming/Prestorming-Batch-6---Mob-Banner.jpg";
import YoutubePlaylist from '../../components/Service/YoutubePlaylist';
import Head from "next/head";

export async function getStaticProps() {

  console.log('test1');
  const API_KEY = 'AIzaSyCTaZ-EjvDGf1b2csRzatL196QCM6u8y4I';
  const PLAYLIST_ID = 'PLolj3WrQmJe5bPtIBG44kjc2TwxX51lzw';
  const res = await axios.get(
    `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=10&playlistId=${PLAYLIST_ID}&key=${API_KEY}`
  );
  const playlistItems = res.data.items || [];
  const playlist = playlistItems.length > 0 ? playlistItems[0] : null;
  return {
    props: {
      playlist,
    },
    //revalidate: 86400, // revalidate data once per day
  };
}



const Prelims = ({playlist}) => { 

  const prelimlist =[
    {list:"43 exclusive tests and 3 UPSC mock tests"},
    {list:"15 comprehensive CSAT tests including sectional and full length test."},
    {list:"Orientation and Discussion for each test."},
    {list:"Artificial Intelligence based analysis with All India Ranking."},
    {list:"Exclusive test on Special Focus Areas like Schemes,Agriculture, etc.,"},
    {list:" Current Affairs classes and classes on focus areas like Environmental Organizations, Environmental Governance, International Organizations, Art and Culture & Science and Technology."},
    {list:" Supplementary Materials - Decoded Syllabus & Analysis of UPSC Prelims Papers (Past 8 Years) will be provided."}
  ]

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "UPSC Prelims Test Series 2026 | Prestorming Test",
    "url": "https://www.shankariasacademy.com/upsc-prestorming-prelims-test-series/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/prestorming-web-banner.6d7ff7f6.jpg",
    "description": "Join UPSC Prelims Test Series 2026 - Prestorming Test by Shankar IAS Academy. Get weekly test series, expert reviews & performance insights."
  }

   const router = useRouter();
  
    useEffect(() => {
      const handleRouteChange = (url) => {
        console.log(`Navigated to ${url}`);
        router.reload(); // Refresh the page on route change
      };
  
      router.events.on("routeChangeComplete", handleRouteChange);
  
      // Cleanup on component unmount
      return () => {
        router.events.off("routeChangeComplete", handleRouteChange);
      };
    }, [router]);
  
  
  return (
    <>
    
            <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>UPSC Prelims Test Series 2026 | Prestorming Test</title>
                <meta name="title" content="UPSC Prelims Test Series 2026 | Prestorming Test" />
                <meta name="description" content="Join UPSC Prelims Test Series 2026 - Prestorming Test by Shankar IAS Academy. Get weekly test series, expert reviews & performance insights." />
                <meta name="Keywords" content=" UPSC Prelims Test Series, UPSC prestorming prelims Test Series 2026, IAS Prelims Test Series, GS Prelims Test Series, UPSC Prelims Test Series for IAS, Test Series for UPSC Prelims 2026,  Test Series for UPSC Prelims, UPSC Prestorming, Best UPSC Coaching in Chennai, Best UPSC Coaching in Anna Nagar"/>
                <link rel="canonical" href="https://www.shankariasacademy.com/upsc-prestorming-prelims-test-series/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="UPSC Prelims Test Series 2026 | Prestorming Test" />
                <meta property="og:description" content="Join UPSC Prelims Test Series 2026 - Prestorming Test by Shankar IAS Academy. Get weekly test series, expert reviews & performance insights." />
                <meta property="og:url" content="https://www.shankariasacademy.com/upsc-prestorming-prelims-test-series/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
                 <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
              </Head>  
    <Navbar title="upsc" />

    <div className="container">
        <div className="row">
              <div className="col pt-3 pt-md-4">
                <h1 className={`${styles.pagemaintitle}`}>
                UPSC Prelims Test Series 2026 | Prestorming Test
                </h1>
              </div>
        </div>
    </div>

 
      <div className="container">
      <div className="row d-none d-md-block">
          <div className="col pt-2 mb-3">
            <Image
              src={Prelimsmain}
              alt="UPSC Prelims Test Series 2026 | Prestorming Test"
              title="UPSC Prelims Test Series 2026 | Prestorming Test"
              className="img-fluid w-100"
            />
          </div>
          </div>

          <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={MobUpsPerlims}
               alt="UPSC Prelims Test Series 2026 | Prestorming Test"
               title="UPSC Prelims Test Series 2026 | Prestorming Test"
               className="img-fluid w-100"
              />
            </div>
          </div>
     
      <div className="row">
          <div className="col pt-2" id="scheduledetails">
           {/* <h2 className={`${styles.sectiontitle} mb-0`}>
              UPSC Prestorming Test Series 2026
            </h2> */}
          </div>
        </div>
      </div>

      {/* <Prelims_Form /> */}

  

      <div className="container pt-2">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3 align-items-baseline`}
            >
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4 active"
                data-bs-toggle="pill"
                data-bs-target="#centre-1"
                type="button"
                role="tab"
                aria-controls="centre-1"
                aria-selected="true"
              >
                Chennai
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-2"
                type="button"
                role="tab"
                aria-controls="centre-2"
                aria-selected="false"
              >
                Delhi
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-3"
                type="button"
                role="tab"
                aria-controls="centre-3"
                aria-selected="false"
              >
                Bengaluru
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-4"
                type="button"
                role="tab"
                aria-controls="centre-4"
                aria-selected="false"
              >
                Trivandrum
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-5"
                type="button"
                role="tab"
                aria-controls="centre-5"
                aria-selected="false"
              >
                Hyderabad
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-6"
                type="button"
                role="tab"
                aria-controls="centre-6"
                aria-selected="false"
              >
                Trichy
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-7"
                type="button"
                role="tab"
                aria-controls="centre-7"
                aria-selected="false"
              >
                Salem
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-8"
                type="button"
                role="tab"
                aria-controls="centre-8"
                aria-selected="false"
              >
                Coimbatore
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-9"
                type="button"
                role="tab"
                aria-controls="centre-9"
                aria-selected="false"
              >
                Madurai
              </button>

              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-10"
                type="button"
                role="tab"
                aria-controls="centre-10"
                aria-selected="false"
              >
               Online 
              </button>

               <Link href='/upsc-previous-question-paper'>
                <button
                  id={styles.blinking}
                  className="nav-link py-1 px-2 px-0 me-4"
                  data-bs-toggle="pill"
                  type="button"
                  role="tab"
                  aria-controls="centre-6"
                  aria-selected="false"
                >
                   Previous Year Question Paper <Image src={handIcon} alt="PDF Icon"width={32} height={32} className="me-1" />
                </button>
              </Link>
            
            </div>
          </div>
        </div>
      </div>
 
      <div className="tab-content">

        <div className="tab-pane active" id="centre-1">
          <Chennai />
        </div>

        <div className="tab-pane" id="centre-2">
          <Delhi />
        </div>

        <div className="tab-pane" id="centre-3">
           <Bengaluru />
        </div>

        <div className="tab-pane" id="centre-4">
          <Trivandrum />  
        </div>

        <div className="tab-pane" id="centre-5">
          <Hyderabad />  
        </div>
        
        <div className="tab-pane" id="centre-6">
          <Trichy />
        </div>

        <div className="tab-pane" id="centre-7">
          <Salem /> 
        </div>

        <div className="tab-pane" id="centre-8">
          <Coimbatore />
        </div>

        <div className="tab-pane" id="centre-9">
          <Madurai /> 
        </div>

        <div className="tab-pane" id="centre-10">
          <Online /> 
        </div>
   
      </div>
     
      <Content /> 

      <div className="container-fluid pb-5"  style={{
    background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",
    opacity: "1",
    }}>
      <div class="container">
        
     <div class="col-12 col-md-6 offset-md-3 mt-4">
        <p className={`${styles.contactheader} text-center`}>Enquiry</p>
        <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
        <div class={`${styles.addmissionform} npf_wgts `} data-height="600px"   data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
    </div>
  </div>
  </div>

 <div
  className="container-fluid py-4 py-md-5 "
  style={{
    background: "linear-gradient(135deg, #f4f6f8, #eaf0f5)",
  }}
>
  <div className="row justify-content-center">
    <div className="col-12 col-md-11 col-xl-10 bg-white shadow-lg rounded-4 p-3 p-md-5">
      <div className="row align-items-center">
        
        {/* Left Column - Title & List */}
        <div className="col-12 col-xl-5 mb-4 mb-xl-0">
          <h2
            className={`${styles.sectiontitle} fw-bold mb-3`}
            style={{
              color: "#1a3c6e",
              fontSize: "1.6rem",
              lineHeight: "1.3",
            }}
          >
            Why <span style={{ color: "#007BFF" }}>Shankar IAS Academy?</span>
          </h2>

          <ul className="list-unstyled ps-0">
            {prelimlist.map((item, index) => (
              <li
                key={index}
                className="d-flex align-items-start mb-2 fade-in"
                style={{
                  animationDelay: `${index * 0.1}s`,
                  fontSize: "0.95rem",
                  lineHeight: "1.4",
                }}
              >
                <i
                  className="bi bi-check-circle-fill me-2 flex-shrink-0"
                  style={{ color: "#ff0000ff", fontSize: "1rem" }}
                ></i>
                <span className={`${styles.acheiverrank}`}>{item.list}</span>
              </li>
            ))}
          </ul>

          <p className="fw-semibold text-secondary mt-2 mb-0">
            & Much More...
          </p>
        </div>

        {/* Right Column - YouTube Playlist */}
        <div className="col-12 col-xl-7">
          <div className="ratio ratio-16x9 rounded-3 overflow-hidden">
            <YoutubePlaylist playlist={playlist} />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



        {/* <ContentOne /> */}
    
     
     {/* <BranchAddress /> */}  
      <Interest />
      <Footer />
    </>
  );
};
export default Prelims;
